<template>
  <div
    :class="isHotelPage ? 'relative w-full' : 'full-width bg-light-turquoise'"
  >
    <div :class="{ 'top-section layout-container mx-auto': !isHotelPage }">
      <div
        class="w-12/12"
        :class="{ 'py-4 md:py-5 p-0 flex flex-col justify-center container mx-auto xl:px-4': !isHotelPage }"
      >
        <Loading v-if="loading" />
        <template v-else-if="packages.length > 0">
          <div class="flex mt-4 mb-4 md:mb-4">
            <span>
              <slot name="title">
                <h2
                  class="font-secondary"
                  :data-i18n="title"
                >{{ $t(title) }}</h2>
              </slot>
            </span>
          </div>
          <p
            v-if="!isHotelPage"
            class="flex mb-4 lg:px-0"
          >
            <span>
              <slot name="subtext">
                <span>
                  {{ subtext ? subtext : $t('charterDestinationHotelSubtext') }}
                </span>
              </slot>
            </span>
          </p>
          <LazySwiper
            class="charter-destination__hotel-list-slider md:-mx-4"
            v-bind="sliderOptions"
          >
            <div
              v-for="(p, index) in packages"
              :key="index"
              class="charter-destination__hotel-list-item pb-4"
            >
              <NewHotelPackageCard
                :hotel="p"
                nested-slider
                use-static-images
              />
            </div>
          </LazySwiper>
          <div
            v-if="!isHotelPage"
            class="flex justify-center mt-12 mb-4"
          >
            <div
              class="book-btn-content btn btn-orange btn-rounded py-2 px-12 font-bold"
              data-i18n="charterAllHotels"
              @click="toPackageSearch"
            >
              {{ $t('charterAllHotels') }}
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
const { localeDate } = useDate()

const props = defineProps({
  destinationId: {
    type: Number,
    default: 0,
  },

  currentId: {
    type: [Number, String],
    default: null,
  },

  title: {
    type: String,
    default: 'selectedHotels',
  },

  subtext: {
    type: String,
    default: null,
  },

  isHotelPage: {
    type: Boolean,
    default: false,
  },
})

const packages = ref([])
const loading = ref(true)
const sliderOptions = {
  centeredSlides: false,
  loop: true,
  autoplay: { delay: 5000 },
  onlyRenderVisibleSlides: true,
  preventSwiperUpdate: true,
  dynamicBullets: true,
  dotsType: 'dark',
  speed: 800,
  pagination: true,
  arrowsType: 'circular',
  arrowsSize: 'sm',
  arrowsColor: 'black',
  dotsAlign: 'outside',
  constantDisplayNavigation: true,
  loadingSkeletonAnimation: 'skeleton-slides',
  loadingSkeletonHeight: '400px',

  slidesPerView: 1,
  initialSlide: localeDate(undefined, 'M') - 1,
  arrowShadow: true,
  breakpoints: {
    0: {
      navigation: false,
    },

    [getTailwindBreakpointsPx().md]: {
      navigation: true,
      constantDisplayNavigation: false,
      arrowsAlign: 'inner-border',
      slidesPerView: 2,
    },

    [getTailwindBreakpointsPx().xl]: {
      slidesPerView: 3,
      constantDisplayNavigation: true,
      arrowsAlign: 'inner-border',
    },
  },
}

const localeStore = useLocaleStore()

const charterPackagesStore = useCharterPackagesStore()
const charterdestinationStore = useCharterDestinationStore()
const { charterDestination } = storeToRefs(charterdestinationStore)
const { filters } = storeToRefs(charterPackagesStore)

onBeforeMount(() => {
  nextTick(() => fetch())
})

const fetch = async () => {
  const destinationId = props.destinationId > 0 ? props.destinationId : charterDestination.value.destination_id
  loading.value = true
  const { data: result } = await apiFetch(
    `/${localeStore.locale}/charter/packages/offers/search`, {
      method: 'post',
      timeout: 60000,
      body: {
        destinations: [destinationId],
        tripLength: {
          'max': 9,
          'min': 7,
        },
        mode: 'hotelList',
      },
    }
  )

  const PACKAGE_SORT_KEY = 'pricepp'
  const filteredResult = result.filter(r => `${r?.giata_id}` !== `${props.currentId}`)

  const sortedPackages = computed(() => {
    return ([...filteredResult] || []).sort((a, b) => a[PACKAGE_SORT_KEY] - b[PACKAGE_SORT_KEY])
  })
  const filteredPackages = computed(() => {
    return sortedPackages.value.map((pkg) => {
      if (!filters.value?.charter_tags) {
        return pkg
      }
      return {
        ...pkg,
        charter_tags: (pkg.charter_tags || []).map((tagId) => {
          if (!filters.value?.charter_tags) {
            return tagId // return the original tagId if charter_tags is undefined
          }
          return filters.value?.charter_tags.find(tag => tag.id === tagId)
        }),
      }
    })
  })
  packages.value = filteredPackages.value

  loading.value = false
}
const toPackageSearch = () => {
  navigateTo(`/destination/${charterDestination.value.id}/hotell`)
}
</script>
